module.exports = __webpack_public_path__ + "img/Arrow.d41d8cd9.svg";